import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { unwrapResponse } from '~/utils/unwrapResponse';
import type { Merchant } from '~~/models/Merchant';

export type MerchantSearchParams = {
	merchantId: MaybeRef<string | undefined>;
};

export const fetchMerchantByIdFn = async (merchantId: string) => {
	const { $api } = useNuxtApp();
	return $api
		.GET(`/merchants/{merchantId}`, {
			params: { path: { merchantId } },
		})
		.then(unwrapResponse);
};

export const useMerchantQuery = (
	options: MerchantSearchParams,
) => {
	const queryClient = useQueryClient();

	const enabled = computed(() => !!unref(options.merchantId));

	const query = useQuery({
		queryKey: ['merchant', options.merchantId],
		queryFn: () => fetchMerchantByIdFn(unref(options.merchantId)!),
		initialData: () => queryClient.getQueryData<Merchant[]>(['merchants'])
			?.find((c) => c?.id === unref(options.merchantId)),
		initialDataUpdatedAt: () =>
			queryClient.getQueryState<Merchant[]>(['merchants'])
				?.dataUpdatedAt,
		enabled,
	});

	return query;
};
